import { render, staticRenderFns } from "./CadastrosPesquisaSatisfacao.vue?vue&type=template&id=6c8bc879&"
import script from "./CadastrosPesquisaSatisfacao.vue?vue&type=script&lang=js&"
export * from "./CadastrosPesquisaSatisfacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports